import logo from "../../logo.png";
import { useLocationSelection } from "../../context/LocationContext";
import { getLocationAddress } from "../../utils/formatters";

function PublicFooter() {
  const { locations } = useLocationSelection();
  const year = new Date().getFullYear();

  return (
    <footer className="footer public-footer">
      <div className="container public-footer-grid">
        <div className="public-footer-brand">
          <img alt="Zayas Kitchen" src={logo} />
          <p>Fresh favorites, weekly specials, and catering made for gathering.</p>
        </div>

        <nav aria-label="Footer navigation" className="public-footer-links">
          <h2>Explore</h2>
          <a href="/menu">Menu</a>
          <a href="/catering">Catering</a>
          <a href="/about">About</a>
          <a href="/contact">Contact</a>
        </nav>

        <div className="public-footer-locations">
          <h2>Locations</h2>
          {locations.length ? (
            locations.map((location) => (
              <address key={location.id}>
                <strong>{location.name}</strong>
                <span>{getLocationAddress(location)}</span>
                {location.phone ? <a href={`tel:${location.phone}`}>{location.phone}</a> : null}
              </address>
            ))
          ) : (
            <p>Locations will appear here when available.</p>
          )}
        </div>
      </div>

      <div className="container public-footer-bottom">
        <p>� {year} Zayas Kitchen. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default PublicFooter;